import { useContext } from "react"
import Form from "react-bootstrap/Form"
import { PriceContext } from "../PriceContext"
import { discountOptions } from "./discountConfig"
import * as styles from "./discount.module.scss"

const Discount = () => {
  const { discount, setDiscount } = useContext(PriceContext)

  const selectedIndex = discountOptions.findIndex((option) => Number(option.factor) === Number(discount))

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const index = Number(e.target.value)
    setDiscount(discountOptions[index].factor)
  }

  return (
    <Form.Select className={styles.discountSelect} size="sm" value={selectedIndex >= 0 ? selectedIndex : 2} onChange={handleChange}>
      {discountOptions.map((option, index) => (
        <option key={option.label} value={index}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  )
}

export default Discount
